// ----------------------------------------------------------------------------
// Template: Index
// ----------------------------------------------------------------------------
// Home Page Template
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'sections/header/header';
import 'sections/headline-block/headline-block';
import 'sections/hero-banner/hero-banner';
import 'sections/hero-countdown/hero-countdown';
import 'sections/fit-guide/fit-guide';
import 'sections/intro-block/intro-block';
import 'sections/fabric-cards/fabric-cards';
import 'sections/sliding-tiles/sliding-tiles';
import 'sections/holiday-banner/holiday-banner';
import 'sections/banner/banner-block';
import 'sections/icon-block/icon-block';
import 'sections/content-panel/content-panel';
import 'sections/faqs/faqs';
import 'sections/related-blogs/related-blogs';
import 'sections/blog-posts/blog-posts';
import 'sections/newsletter/newsletter';
import 'sections/footer/footer';
import 'sections/video-player/video-player';
import 'sections/homepage-tiles/homepage-tiles';
import 'sections/image-banner/image-banner';


// Styles
